// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3-keq","heading":"_1vabd","content-title":"bcPM4","content":"jA-jz","fields-wrapper":"_1cBRQ","msg":"_3jvY1","failure":"_1KfDS","widget-wrapper":"_3kSk7"};